import BrandingThemesTableList from '@/components/brandingThemes/list/BrandingThemesTableList';
import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetBrandingThemesList } from '@/hooks/requests/useBrandingThemes';
import { useGetCompanyDetails } from '@/hooks/requests/useCompanies';
import { Card } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function BrandingThemesList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryConfig = Object.fromEntries([...searchParams]);
  const companyId = queryConfig.company;
  const { brandingThemes, isBrandingThemesPending } = useGetBrandingThemesList(
    companyId ? { company_id: companyId } : { level: 'Program' },
  );
  const { companyDetails, isCompanyDetailsLoading } = useGetCompanyDetails(
    companyId || '',
  );

  const header = companyDetails
    ? `${companyDetails.name}'s Branding Themes`
    : 'Program Branding Themes';

  if (isBrandingThemesPending || (!!companyId && isCompanyDetailsLoading)) {
    return (
      <DefaultLayout header={header}>
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  function handleAddButtonClick() {
    navigate(
      companyId
        ? `${ROUTES.BRANDING_THEME_ADD}?company=${companyId}`
        : ROUTES.BRANDING_THEME_ADD,
    );
  }

  return (
    <DefaultLayout
      header={header}
      buttons={[
        <SVButton
          fullWidth
          key="add"
          variant="outlined"
          onClick={handleAddButtonClick}>
          Add
        </SVButton>,
      ]}>
      <Card>
        <BrandingThemesTableList
          brandingThemes={brandingThemes}
          showDefaultBrandingThemeRadio={!companyId}
        />
      </Card>
    </DefaultLayout>
  );
}
